import { autoUpdate, computePosition, flip, hide, offset, shift } from "@floating-ui/dom";

//#region src/vanilla/popover/index.ts
const padding = 20;
const initPopover = ({ id, disableAutoPlacement = false, placement = "top", positionMiddleware = [] }) => {
	let cleanup;
	const popover = document.getElementById(id);
	const triggerSelector = `[aria-controls="${id}"]`;
	const trigger = document.querySelector(triggerSelector);
	if (!popover || !trigger) return;
	const togglePopover = (open) => {
		if (open) {
			cleanup = autoUpdate(trigger, popover, () => {
				computePosition(trigger, popover, {
					middleware: [
						offset(padding),
						...disableAutoPlacement ? [] : [flip({ padding }), shift({ padding })],
						...positionMiddleware,
						hide({ padding })
					],
					strategy: "fixed",
					placement
				}).then(({ x, y, middlewareData }) => {
					popover.style.translate = `${x}px ${y}px`;
					popover.style.visibility = middlewareData.hide?.referenceHidden ? "hidden" : "visible";
				});
			});
			popover.setAttribute("aria-hidden", "false");
			trigger.setAttribute("aria-expanded", "true");
		} else {
			cleanup?.();
			popover.setAttribute("aria-hidden", "true");
			trigger.setAttribute("aria-expanded", "false");
		}
	};
	document.addEventListener("click", (event) => {
		const el = event.target;
		const isTrigger = el?.closest?.(triggerSelector);
		const isOutside = !isTrigger && !popover.contains(el);
		const isOpen = popover.getAttribute("aria-hidden") === "false";
		if (isTrigger) togglePopover(!isOpen);
		if (isOutside && isOpen) togglePopover(false);
	}, true);
};

//#endregion
export { initPopover };
//# sourceMappingURL=popover-CGNoywPj.js.map